(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.helpers = window.Dashboard.helpers || {};

    class StateHelper {

        /**
         * Gets the parent state from a current state, for example, if the current state
         * is app.callcenterusers.edituser, then app.callcenterusers will be returned
         * @param currentState
         * @returns {string}
         */
        getParentState(currentState) {
            return this._getStateAtLevel(currentState, -1);
        }

        getGrandparentState(currentState) {
            return this._getStateAtLevel(currentState, -2);
        }

        _getStateAtLevel(state, level) {
            const
                parts = state.split("."),
                result = parts.slice(0, parts.length + level);
            return result.join(".");
        }

        /**
         * Gets the child state from a current state, for example, if the current state
         * is app.callcenterusers.edituser, then edituser will be returned
         * @param currentState
         * @returns {string}
         */
        getChildState(currentState) {
            const parts = currentState.split(".");
            return parts[parts.length - 1];
        }
    }

    window.Dashboard.helpers.stateHelper = new StateHelper();
})();
